import { Box, styled } from '@mui/system';

export const ScoresWrapper = styled(Box)(({ columns = 3 }) => ({
    width: '100%',

    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridTemplateRows: 'max-content 1fr',
    gridAutoFlow: 'column',
    columnGap: 6,

    justifyContent: 'stretch',
    justifyItems: 'stretch',
}));
